module.exports = __webpack_public_path__ + "img/6-2.a9606e95.png";